import { __awaiter } from "tslib";
import { useState, useCallback, useRef } from 'react';
import { useDebounceFn } from 'ahooks';
const useAntModal = (options) => {
    const { handleOkCallback, handleCancelCallback, requestErrorCallback, okDebounceOptions = { wait: 500, leading: false, trailing: true }, } = options || {};
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const successRef = useRef(true);
    const showModal = useCallback(() => {
        setVisible(true);
    }, [setVisible]);
    const closeModal = useCallback(() => {
        setVisible(false);
    }, [setVisible]);
    const handleOk = useCallback((...args) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            handleOkCallback && (yield handleOkCallback(args));
            successRef.current && setVisible(false);
        }
        catch (error) {
            requestErrorCallback && requestErrorCallback(error);
        }
        finally {
            setLoading(false);
        }
    }), [handleOkCallback, requestErrorCallback, setLoading, setVisible]);
    const { run } = useDebounceFn((...args) => {
        handleOk(args);
    }, okDebounceOptions);
    const handleCancel = useCallback((...args) => {
        setVisible(false);
        handleCancelCallback && handleCancelCallback(args);
    }, [handleCancelCallback]);
    return {
        showModal,
        closeModal,
        handleOk: run,
        handleCancel,
        open: visible,
        visible,
        loading,
        successRef,
        commonAntModalProps: {
            open: visible,
            onOk: run,
            onCancel: handleCancel,
            okButtonProps: {
                loading,
            },
        },
    };
};
export default useAntModal;
//# sourceMappingURL=index.js.map